
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { DATE_TYPE } from '@/const/types';

const defaultPicker = {
    shortcuts: [
        {
            text: '오늘',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        }, 
        {
            text: '어제',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, start]);
            },
        },
        {
            text: '일주일 전',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, start]);
            },
        },
        {
            text: '1개월 전',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 1);
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, start]);
            },
        },
        {
            text: '1년 전',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setFullYear(start.getFullYear() - 1);
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, start]);
            },
        }, 
        {
            text: '이번 주',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() - 1));

                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        }, 
        {
            text: '지난 주',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * (start.getDay() - 1 + 7));
                end.setTime(end.getTime() - 3600 * 1000 * 24 * (end.getDay()));
                end.setHours(23);

                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '최근 3일',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);

                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '최근 5일',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 4);

                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        }, 
        {
            text: '최근 7일',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);

                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        }, 
        {
            text: '최근 14일',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 13);

                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        }, 
        {
            text: '최근 1개월',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 1);
                start.setDate(end.getDate());
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        }, 
        {
            text: '최근 3개월',
            onClick(picker: any) {
                const end = new Date(); const start = new Date();
                start.setMonth(start.getMonth() - 3);
                start.setDate(end.getDate());
                
                start.setHours(0); start.setMinutes(0); start.setSeconds(0); start.setMilliseconds(0);
                end.setMinutes(0); end.setSeconds(0); end.setMilliseconds(0);
                picker.$emit('pick', [start, end]);
            },
        },
    ],
};

@Component<DateRangePicker>({
    name: 'DateRangePicker',
})
export default class DateRangePicker extends Vue {
    @Prop({ type: Boolean, default: false }) private disabled!: boolean;
    @Prop({ type: String, default: '' }) private className!: string;
    @Prop({ type: Array, default: ['', ''] }) private value!: string[];
    @Prop({ type: String, default: '시작일' }) private startPlaceholder!: string;
    @Prop({ type: String, default: '종료일' }) private endPlaceholder!: string;
    @Prop({ type: Object, default: () => defaultPicker}) private pickerOptions!: {
        [key: string]: any;
        shortcuts: {
            [key: string]: any;
            text: string;
        };
    };
    @Prop({ type: Function, default: (v: Date[]) => {}}) private change!: (v: Date[]) => any;
    @Prop({ type: Array,
        default: () => ['오늘','어제','이번 주','지난 주', '최근 7일','최근 1개월', '최근 3개월']
    }) private pickerRange!: string[];
    @Prop({ type: Number, default: 180}) private maxDate!: number;
    @Prop({ type: String, default: 'right'}) private align!: string;
    get model() {
        return this.value;
    }
    set model(v) {
        if (v) {
            const tmp = v as DATE_TYPE[];
            const times = tmp as Date[];
            const sub = times[1].getTime() - times[0].getTime();
            if ( -(3600 * 1000 * 24 * this.maxDate) <= sub && sub <= 3600 * 1000 * 24 * this.maxDate) {
                this.$emit('input', v);
                return;
            }
            this.$notify.error(`최대 ${this.maxDate}일까지 조회가 가능합니다.`);
        }
        this.$emit('input', v);
    }

    get pickers() {
        if (this.pickerRange.length === 0) {
            return {
                ...this.pickerOptions,
                disabledDate: this.disabledDate,
            };
        }
        return {
            ...this.pickerOptions,
            shortcuts: this.pickerRange.map((rule: string) => {
                return this.pickerOptions.shortcuts.find(
                    (v: {text: string, [key: string]: any}) => v.text === rule
                );
            }),
            disabledDate: this.disabledDate,
        }
    }
    

    private disabledDate(time: Date) {
        return time.getTime() > Date.now();
    }
}

